// components
import { Head } from "components/molecules/Head/Head";
import { Form, Input, Button as ANTButton } from "antd";
import Label from "components/atoms/Label/Label";
import Button from "components/atoms/Button/Button";
import LoginVerificationWrapper from "components/molecules/Login/Login";
import QRCode from "react-qr-code";

// styles
import styles from "containers/LoginVerification/loginVerification.module.css";

// constants
import { PageTitles, LoginPage as LoginPageConstants } from "constants/global";

type ComponentProps = {
	loginVerificationProps: {
		QRCodeImage: string;
		qrCodeStr: string;
		otpString: string;
		showSetup: boolean;
		isInvalidTOTPErr: boolean;
		fieldErrs: { totp: boolean };
		validateTOTPString: () => void;
		onLinkOTP: () => void;
		setOTPString: (val: string) => void;
		onVerifyOTP: () => void;
		backToLogin: () => void;
	};
};

const LoginVerification = ({ loginVerificationProps }: ComponentProps) => {
	const { QRCodeImage, fieldErrs, qrCodeStr, otpString, showSetup, isInvalidTOTPErr, backToLogin, validateTOTPString, onLinkOTP, onVerifyOTP, setOTPString } =
		loginVerificationProps;

	return (
		<LoginVerificationWrapper page="reset" isDisclaimer={true} showDesign={!showSetup} isSubHeader={!showSetup} subHeader={LoginPageConstants?.SUB_HEADER}>
			<div className={styles?.login_form}>
				<Head>{PageTitles?.FIRST_TIME_LOGIN}</Head>
				{isInvalidTOTPErr && <span className={styles?.form_err}>{LoginPageConstants?.INVALID_OTP}</span>}
				<Form name="register" initialValues={{}} scrollToFirstError layout="vertical">
					{showSetup ? (
						<div className={styles?.wrapper}>
							<QRCode value={QRCodeImage} size={200} />
							<Input value={qrCodeStr} />

							<Form.Item
								extra={fieldErrs?.totp && <span className={styles?.form_err}>{LoginPageConstants?.TOTP_REQUIRED}</span>}
								name={LoginPageConstants?.FIELD_TOTP}
								label={<Label label={LoginPageConstants?.TOTP_LABEL} classes={{ label: styles?.basic_input_label }} requiredMark />}
								className={styles?.username_label}
							>
								<Input
									data-testid={LoginPageConstants?.FIELD_TOTP}
									size="large"
									placeholder={LoginPageConstants?.TOTP_LABEL}
									value={otpString}
									onChange={(e) => {
										setOTPString(e.target.value);
									}}
									onBlur={() => validateTOTPString()}
									onPressEnter={onLinkOTP}
								/>
							</Form.Item>
							<Button onClick={onLinkOTP} label={<span className={styles?.button_label}>{LoginPageConstants.VERIFY_BUTTON}</span>} />
						</div>
					) : (
						<div className={styles?.wrapper}>
							<Form.Item
								extra={fieldErrs?.totp && <span className={styles?.form_err}>{LoginPageConstants?.TOTP_REQUIRED}</span>}
								name={LoginPageConstants?.FIELD_TOTP}
								label={<Label label={LoginPageConstants?.TOTP_LABEL} classes={{ label: styles?.basic_input_label }} requiredMark />}
								className={styles?.username_label}
							>
								<Input
									data-testid={LoginPageConstants?.FIELD_TOTP}
									autoFocus
									size="large"
									placeholder={LoginPageConstants?.TOTP_LABEL}
									value={otpString}
									onChange={(e) => {
										setOTPString(e.target.value);
									}}
									onBlur={() => validateTOTPString()}
									onPressEnter={onVerifyOTP}
								/>
							</Form.Item>
							<Button onClick={onVerifyOTP} label={<span className={styles?.button_label}>{LoginPageConstants.VERIFY_BUTTON}</span>} />
						</div>
					)}
					<ANTButton className={styles?.link_button} type="link" onClick={backToLogin}>
						{LoginPageConstants.BACK_TO_LOGIN}
					</ANTButton>
				</Form>
			</div>
		</LoginVerificationWrapper>
	);
};

export default LoginVerification;
